export const OPEN_TOUR_SEARCH = 'openTourSearch';

export const openTourSearch = () => {
    window.dispatchEvent(new Event(OPEN_TOUR_SEARCH));
};
